import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import venueActions from 'actions/venues/actions'
import View from 'components/merchant/view';
import BackToVenuesList from 'components/merchant/venues/back';
import VenueDetails from 'forms/merchant/venues/venue-details';
import VenueContacts from 'forms/merchant/venues/venue-contacts';
import VenueSpaces from 'forms/merchant/venues/venue-spaces';
import { FORM_SECTIONS } from 'constants/user-venues';

const styles = {
  active: {
    tab: 'cursor-pointer bg-white w-full block border-r-2 rounded-t-lg py-3 px-8 text-sm text-orange-500 flex items-center',
    sectionIdx: 'mr-4 bg-orange-500 text-xs text-white rounded-full h-6 w-6 flex items-center justify-center',
  },
  inActive: {
    tab: 'cursor-pointer bg-gallery w-full block border-r-2 rounded-t-lg py-3 px-8 text-sm text-gray-600 flex items-center',
    sectionIdx: 'mr-4 bg-gray-500 text-xs text-gray-600 rounded-full h-6 w-6 flex items-center justify-center',
  },
};

const tabs = [
  { title: 'Venue Details', section: FORM_SECTIONS.DETAILS, form: VenueDetails },
  { title: 'Venue Contacts', section: FORM_SECTIONS.CONTACTS, form: VenueContacts },
  { title: 'Venue Spaces', section: FORM_SECTIONS.SPACES, form: VenueSpaces },
];

const VenueForm = ({ match, setAction, resetDetails }) => {
  const venueId = Number(match.params.venueId)
  const isEdit = Number.isInteger(venueId)
  const action = isEdit ? 'edit' : 'add'
  useEffect(() => {
    const payload = {
      id: isEdit ? venueId : null,
      action
    }
    setAction(payload)
  }, [venueId])

  useEffect(() => {
    return () => {
      resetDetails()
    };
  }, []);

  const [selectedSection, setSelectedSection] = useState(FORM_SECTIONS.DETAILS);

  const [successSection, setSuccessSection] = useState({
    [FORM_SECTIONS.DETAILS]: false,
    [FORM_SECTIONS.CONTACTS]: false,
    [FORM_SECTIONS.SPACES]: false
  })

  const handleSetSuccess = (value) => {
    setSuccessSection({ ...successSection, ...value })
  }

  const handleClick = (section) => {
    const sectionValues = Object.values(FORM_SECTIONS)
    const index = sectionValues.indexOf(section)
    const nextSection = sectionValues[index - 1] ? successSection[sectionValues[index - 1]] : false
    if (successSection[section] || nextSection || isEdit) setSelectedSection(section)
  }

  const renderTabs = () => {
    const RenderTabComponent = tabs.find(t => t.section === selectedSection).form;
    return (
      <Fragment>
        <ul className='flex'>
          {
            tabs && tabs.map(({ title, section }, idx) => {
              const isActive = selectedSection === section;
              return (
                <li className='flex-1' key={section}>
                  <div className={isActive ? styles.active.tab : styles.inActive.tab} onClick={() => handleClick(section)}>
                    <span className={isActive ? styles.active.sectionIdx : styles.inActive.sectionIdx }>{ idx + 1 }</span>
                    <span>{title}</span>
                  </div>
                </li>
              );
            })
          }
        </ul>
        <RenderTabComponent venueId={venueId} form="merchant-venue-form" action={action} handleSetSuccess={handleSetSuccess} setSelectedSection={setSelectedSection} rootClassName='bg-white py-6 px-10'/>
      </Fragment>
    );
  };

  return (
    <View theme="grey" customClass="pr-20">
      <BackToVenuesList />
      { renderTabs() }
    </View>
  );
};

VenueForm.propTypes = {
  match: PropTypes.object,
  setAction: PropTypes.func,
  resetDetails: PropTypes.func
};

const mapDispatchToProps = {
  setAction: venueActions.setAction,
  resetDetails: venueActions.resetDetails
}

export default connect(null, mapDispatchToProps)(VenueForm);
